/* Component Dependencies */
var shortlistedRfpProperties = require('templates/shortlistedRfpProperties.hbs');
var AriesComponent = require('libs/aries-component');
var selectedHotelsTemplate = require('../../partials/selectedHotels.hbs');
var _ = require('lodash');
var Popup = require('libs/popup');
var RfpPopupVal = 0;

AriesComponent.create({
  type: 'shortlistedRfpProperties',
  template: {
    'shortlistedRfpProperties': shortlistedRfpProperties
  },
  events: {
    'click .l-hotel-remove': 'handleRemoveClick',
    'click .js-listing-heading-text.is-open, .js-expand-collapse.is-open': 'collapseShortlistingView',
    'click .js-listing-heading-text.is-collapsed, .js-expand-collapse.is-collapsed': 'expandShortlistingView',
    'click .l-listing-cta': 'onRFPSubmit',
    'click .l-container': 'toggleShortListingView'
  },
  subscribe: {
    'GROUP_RFP_REQUEST_REMOVE': 'removeFromRFP',
    'GROUP_RFP_REQUEST_ADD': 'addToRFP',
    'SEARCH_FILTER_VISIBLE': 'hideShortListedRfpProperties',
    'SEARCH_FILTER_HIDDEN': 'showShortListedRfpProperties'
  },
  constants: {
    MAX_PROPERTIES: 3,
    TIMEOUT_INTERVAL: 5000,
  },
  data: {},
  cache: {},
  bindEvents: function() {
    this.cacheElements();
    this.initializeModel();
    this.updateSubmitURL();
    this.startAutoCollapseTrigger();
    this.makePaginationSticky();
    this.registerPopUp();
  },
  /**
   * This function initializes the data model
   */
  initializeModel: function() {
    this.data.json = this.$el.data('json');
    this.data.propertyCollection = this.data.json.propertyList;
    this.data.endpointURL = this.data.json.shortlistRfpActionUrl;
    this.data.removeActionType = this.data.json.removeActionType;
    this.data.addActionType = this.data.json.addActionType;
    this.data.showLabel = this.data.json.labels.showProperties;
    this.data.hideLabel = this.data.json.labels.hideProperties;
    this.data.isShown = this.data.propertyCollection.length !== 0;
    this.data.isExpanded = this.data.isShown;
    this.data.collapseClass = 'is-collapsed';
    this.data.openClass = 'is-open';
    this.data.ritzSubmitURL = this.data.json.rfpSubmitLink.ritzBaseUrl;
    this.data.queryParams = this.data.json.rfpSubmitLink.queryParams.map(function(obj){ return obj.key + '=' + obj.value}).join('&');
    this.data.queryParams = this.data.queryParams + '&' + this.data.json.rfpSubmitLink.marshaQueryParam + '=';
    this.data.submitURL = this.data.json.rfpSubmitLink.rfpSubmitUrl;
    this.data.maxLimitReachedMessage = this.data.json.maxLimitReached;
  },
  /**
   * This function caches the elements from the DOM for reuse later on
   */
  cacheElements: function() {
    this.cache.submitCTA = this.$el.find('.l-listing-cta');
    this.cache.shortlistingHeading = this.$el.find('.js-listing-heading-text');
    this.cache.selectedHotels = this.$el.find('.l-selected-hotels');
    this.cache.arrowIcon = this.$el.find('.js-arrow-icon');
    this.cache.count = this.$el.find('.l-property-count');
  },
  makePaginationSticky: function(){
    if(this.data.isShown){
      this.pubsub.publish('GROUP_RFP_TILE_PRESENT', [this.data.isShown]);
    }
  },
  
    /* Register Pop up */
    registerPopUp: function() {
      if(this.$el.find('.t-promos-title').length){
        var showPopup = new Popup({
          sourceBlock: '.modal-content',
          selector: '.t-promos-title',
        });
          showPopup.register();
      }
    },
  /**
   * This function is a subscriber for when someone tries to add to eRFP
   */
  addToRFP: function(propertyModel) {
    if ( this.canAddMore() ) {
      this.makeAjaxCall({
        url: this.data.endpointURL,
        data: JSON.stringify( {promoId: propertyModel.promoId, marshaCode: propertyModel.marshaCode, actionType: this.data.addActionType} ),
        method: 'POST'
      });
      this.addToPropertyCollection(propertyModel);
      this.reRenderSelectionView();
      this.pubsub.publish('GROUP_RFP_ADD_HOTEL', [propertyModel.marshaCode]);
    } else  {
      alert(this.data.maxLimitReachedMessage);
    }
  },
  /**
   * This function is a subscriber for when someone tries to remove from eRFP
   */
  removeFromRFP: function(marshaCode) {
    if( this.canRemoveMore() ) {
      this.makeAjaxCall({
        url: this.data.endpointURL,
        data: JSON.stringify( {marshaCode: marshaCode, actionType: this.data.removeActionType} ),
        method: 'POST'
      });
      this.removeFromPropertyCollection(marshaCode);
      this.reRenderSelectionView();
      this.pubsub.publish('GROUP_RFP_REMOVE_HOTEL', [marshaCode]);
    }
  },
  /**
   * This function handles the remove button click on the shortlisting tile
   */
  handleRemoveClick: function(event) {
    event.stopPropagation();
    var $currentTarget = $(event.currentTarget),
      removedMarshaCode = $currentTarget.data('marsha-code');
      
    this.removeFromRFP(removedMarshaCode);
    this.pubsub.publish('GROUP_RFP_REMOVE_HOTEL', [removedMarshaCode]);
  },
  /**
   * This function initiates the autocollapse when shortlisting tile is expanded
   */
  startAutoCollapseTrigger: function() {
    var _self = this;
    _self.timeout = setTimeout( function() {
      _self.collapseShortlistingView();
    }, _self.constants.TIMEOUT_INTERVAL );
  },
  /**
   * This function increase the interval when autocollapse is enabled and use does some interaction
   */
  extendAutoCollapseInterval: function() {
    this.clearAutoCollapse();
    this.startAutoCollapseTrigger();
  },
  /**
   * This function clears the autoCollapse when shortlisting tile is collapsed
   */
  clearAutoCollapse: function() {
    clearTimeout(this.timeout);
  },
  /**
   * This function shows the shortlisting tile when user adds a new product for the first time
   */
  showShortlistingView: function() {
    this.data.isShown = true;
    this.$el.removeClass('l-display-none');
  },
  toggleShortListingView: function _toggleShortListingView(e) {
    var $currentTarget = $(e.currentTarget), $emptyCard, $imageContainer, $hotelName, $target = $(e.target);
    $emptyCard = $currentTarget.find('.l-property-card-empty');
    $imageContainer = $currentTarget.find('.l-property-image');
    $hotelName = $currentTarget.find('.l-hotel-name');
    $promos = $currentTarget.find('.t-promos-title');
    if( ($emptyCard.length &&  ($emptyCard.is($target) || $.contains($emptyCard.get(0), e.target))) ||
        ($imageContainer.length &&  ($imageContainer.is($target))) || ($hotelName.length &&  ($hotelName.is($target))) || ($promos.length &&  ($promos.is($target) || ($promos.find($target).length))) ) {
      return; 
    }

    if(this.cache.shortlistingHeading.hasClass('is-open')) {
      this.collapseShortlistingView(e);
    }else {
      this.expandShortlistingView(e);
    }
  },
  /**
   * This function expands the shortlisting view
   */
  expandShortlistingView: function(event) {
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if(!this.data.isShown) {
      this.showShortlistingView();
    }
    if(!this.data.isExpanded) {
      this.data.isExpanded = true;
      this.$el.removeClass(this.data.collapseClass);
      this.cache.arrowIcon.removeClass(this.data.collapseClass).addClass(this.data.openClass);
      this.cache.arrowIcon.removeClass('t-icon-arrow-up').addClass('t-icon-arrow-down');
      this.cache.shortlistingHeading.removeClass(this.data.collapseClass).addClass(this.data.openClass).text(this.data.hideLabel);
      this.startAutoCollapseTrigger();
    }
    this.extendAutoCollapseInterval();
  },
  /**
   * This function collapses the shortlisting view
   */
  collapseShortlistingView: function(event) {
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    } 
    this.data.isExpanded = false;
    this.$el.addClass(this.data.collapseClass);
    this.cache.arrowIcon.removeClass(this.data.openClass).addClass(this.data.collapseClass);
    this.cache.arrowIcon.removeClass('t-icon-arrow-down').addClass('t-icon-arrow-up');
    this.cache.shortlistingHeading.removeClass(this.data.openClass).addClass(this.data.collapseClass).text(this.data.showLabel);
    this.clearAutoCollapse();
  },
  /**
   * Re-rendering the properties when user adds or removes a property
   */
  reRenderSelectionView: function() {
    this.cache.selectedHotels.empty()
      .append(selectedHotelsTemplate(this.data.json));
    this.updateSelectionCount();
    this.expandShortlistingView();
    this.registerPopUp();
  },
  /**
   * Updates the count of selected properties(seen in mobile viewport) when user adds or removes a property
   */
  updateSelectionCount: function() {
    this.cache.count.text( this.data.propertyCollection.length );
  },
  /**
   * Validates if more properties can be added
   */
  canAddMore: function() {
    var isModal = $('.js-add-to-rfp-btn').parents('.m-modal').length;
    if(isModal){
      return this.data.propertyCollection.length - RfpPopupVal < this.constants.MAX_PROPERTIES;
    } else {
      return this.data.propertyCollection.length < this.constants.MAX_PROPERTIES;
    }
  },
  /**
   * Validates if more properties can be removed 
   */
  canRemoveMore: function() {
    return this.data.propertyCollection.length > 0;
  },
  /**
   * This function adds a newly selected property to the propertyCollection
   */
  addToPropertyCollection: function(propertyModel) {
    if( this.canAddMore() ) {
      //Insert the propertyModel at the next index
      var isModal = $('.js-add-to-rfp-btn').parents('.m-modal').length;
      if(isModal) {
        RfpPopupVal = ++RfpPopupVal;
        this.data.propertyCollection.push( propertyModel );
      } else {
        this.data.propertyCollection.push( propertyModel );
      }
    }
    if( this.data.propertyCollection.length === 1 ) {
      this.cache.submitCTA.removeClass('is-disabled');
    }
    this.updateSubmitURL();
  },
  /**
   * This function removes a newly selected property from the propertyCollection
   */
  removeFromPropertyCollection: function(marshaCode) {
    var index;
    index = _.findIndex(this.data.propertyCollection, {marshaCode: marshaCode});
    if( index >= 0 ) {
      this.data.propertyCollection.splice(index, 1);
      this.reRenderSelectionView();
    }
    if( !this.canRemoveMore() ) {
      this.cache.submitCTA.addClass('is-disabled');
    }
    this.updateSubmitURL();
  },
  /**
   * This function updates the submit URL
   */
  updateSubmitURL: function() {
    var properties = this.data.propertyCollection.map( function(property) {
      return property.marshaCode;
    } ).join(','),
      submitURL = this.getSubmitURL();
    submitURL += (submitURL.indexOf('?') === -1 ? '?' : '&');
    submitURL += this.data.queryParams + properties;
    this.cache.submitCTA.attr('href', submitURL );
  },
  /**
   * This function returns the count of selected Ritz Carlton Properties
   */
  getRitzPropertiesCount: function() {
    return _.filter(this.data.propertyCollection, {isRitzCarlton: true}).length;
  },
  /**
   * This function returns the submit URL based on Ritz property rule
   */
  getSubmitURL: function() {
    if (this.getRitzPropertiesCount() > 0 && this.data.propertyCollection.length === 1) {
      this.cache.submitCTA.attr('target', '_blank');
      return this.data.ritzSubmitURL;
    }else {
      this.cache.submitCTA.removeAttr('target');
      return this.data.submitURL;
    }
  },
  /**
   * This function validates the property list on submit
   */
  onRFPSubmit: function(event) {
    event.stopPropagation();
    if( this.data.propertyCollection.length === 0 ) {
      event.preventDefault();
    }
  },

  hideShortListedRfpProperties: function() {
    this.$el.addClass('l-display-none');
  },

  showShortListedRfpProperties: function() {
    if(this.data.isShown){
      this.$el.removeClass('l-display-none');
    }
  }
});